__turbopack_context__.v({
  "footerTop": "LuhifG_footerTop",
  "footerTopDownload": "LuhifG_footerTopDownload",
  "footerTopNav": "LuhifG_footerTopNav",
});
